class MapApplication {

    constructor() {
      this.vm = null
      this.map = null;
    }
  
    /**
      * 初始化地图
      * @param {*} vm 
      */
    initMap(vm) {
  
      this.vm = vm;
      this.map = new esmap.ESMap({
        container: document.getElementById("map-container"), //地图初始化的容器
        mapDataSrc: "./static/esmap/data", //地图数据所在目录
        mapThemeSrc: "./static/esmap/data/theme", //地图主题所在目录
        themeID: 1004, //请确保主题目录下存在该主题的数据包
        // token应该填写在esmap官网创建该地图时所填写的token，每个地图ID对应一个唯一的token
        token: 'escope',
        focusAnimateMode: true, //开启聚焦层切换的动画显示
      });
      this.map.openMapById(this.vm.mapID);//显示地图数据
      this.map.showCompass = true; //显示指南针 
      this.map.panorama = true;
      var ctlOpt = new esmap.ESControlOptions({
        position: esmap.ESControlPositon.RIGHT_TOP,
        //注意：imgURL参数是static目录下图片的路径
        imgURL: "./static/esmap/image/wedgets"
      });
  
      let _this = this;
  
      this.map.on("loadComplete", function () {//加载事件
        //创建楼层控件
        var floorControl = new esmap.ESScrollFloorsControl(_this.map, ctlOpt);
        var fnum = _this.map.focusFloorNum;
        var floorLayer = _this.map.getFloor(fnum);
        console.log(floorLayer);
        var gpos = floorLayer.mapCoord;
        
        

        /*let pos=0;
        //先执行显示一次；
        setTimeout(function () {
          CallLoadData(0)
        },10);
        //开启定时器从后台获取数据
        setInterval(function () {
          CallLoadData((++pos % 2));
        }, 5000);*/
      });

      function CallLoadData(pos) {//定时改变铺位颜色方法
            var id = [];
            var fileName = 'data' + pos + '.json'; //json数据切换
            $.getJSON(fileName, function (data) {
            	var mydata=new Map();
                parkData = data.put;
                //1.解析数据,将数据按每层进行整理
                var total =  0;
                for (var i = 0, len = parkData.length; i < len; ++i) {
                    var m = parkData[i];
                    var d=mydata.get(m.fnum);
                   
                    if(d==null)
                    {
                        d = {"idlist":[[],[],[]]};
                    }
                    total++;
                    d.idlist[m.status].push(m.ID);
                    mydata.set(m.fnum,d);
                }

                var showtext="";
                //2.更新车位颜色
                for (var i = 1; i < mydata.size; i++) {debugger;
                    var d1 = mydata.get(i);
                    var fnum = i;
                    for(var j=0;j<color.length;j++)
                    {
                    	//调用批量修改颜色接口来修改
                        this.map.changeModelColor({
                            id:d1.idlist[j],
                            fnum: fnum,
                            color: color[j]
                        });
                    }
                    showtext += this.map.floorNames[fnum-1]+":"+d1.idlist[2].length+"个  ";
                }               

                //3.显示更新统计
                $("#freedata").html(showtext); //滚动字幕 相应楼层剩余停车位数           
                $("#total").html(total);
            });
        }

      var startPick = true; // 控制是否弹出信息框

      //点击事件
      this.map.on('mapClickNode', function(event) {
        if (event.nodeType == esmap.ESNodeType.NONE || event.nodeType == esmap.ESNodeType.FLOOR) return;
        var model = event;
        if (!startPick) return;
        if(event.nodeType == esmap.ESNodeType.IMAGE_MARKER||event.nodeType == esmap.ESNodeType.TEXT_MARKER) 
            model.flash&&model.flash({
                    scale: 1.3,
                    time: 0.3
                }); //闪烁
        var d;
        switch (event.nodeType) {
            case esmap.ESNodeType.MODEL:
                d = {
                    type: event.typeID,
                    ID: event.ID,
                    fnum: event.FloorNum,
                    name: !event.name ? "暂无" : event.name,
                    x: event.label ? event.label.mapCoord.x : event.mapCoord.x,
                    y: event.label ? event.label.mapCoord.y : event.mapCoord.y,
                    z: event.label ? event.label.mapCoord.z : event.mapCoord.z
                };
                //打开遮罩层
                document.getElementById("bg").style.display ="block";
                document.getElementById("show").style.display ="block";
                //帆软报表url
                $("#ppxx").after('<iframe src="'+window.context.front+"templateReport/bfc_czj%2Fpreview=false%3Fparam=finereportUrl2"+'" style="height: 75%;width: 60%;"></iframe>');
                $("#pwbh").text("铺位编号："+d.name);
                $("#lc").text("楼层：负"+d.fnum+"楼");
                $("#ppmc").text("品牌名称："+d.name);
                $("#zbx").text("坐标x："+d.x);
                $("#zby").text("坐标y："+d.y);
                break; //打开对话框
            case esmap.ESNodeType.TEXT_MARKER:
                d = {
                    type: event.nodeType,
                    ID: event.ID,
                    name: !event.name ? "暂无" : event.name,
                    fnum: event.FloorNum,
                    x: event.x,
                    y: event.y,
                    z: event.z
                };
                //打开遮罩层
                document.getElementById("bg").style.display ="block";
                document.getElementById("show").style.display ="block";
                //帆软报表url
                $("#ppxx").after('<iframe src="'+window.context.front+"templateReport/bfc_czj%2Fpreview=false%3Fparam=finereportUrl2"+'" style="height: 75%;width: 60%;"></iframe>');
                $("#pwbh").text("铺位编号："+d.name);
                $("#lc").text("楼层：负"+d.fnum+"楼");
                $("#ppmc").text("品牌名称："+d.name);
                $("#zbx").text("坐标x："+d.x);
                $("#zby").text("坐标y："+d.y);
                break; //打开对话框
            case esmap.ESNodeType.FACILITY:
            case esmap.ESNodeType.IMAGE_MARKER:
                {
                    d = {
                        type: event.nodeType,
                        fnum: event.FloorNum,
                        name: !event.name ? "暂无" : event.name,
                        ID:event.ID,
                        x: event.mapCoord.x,
                        y: event.mapCoord.y,
                        z: event.mapCoord.z
                    };
                    //打开遮罩层
                    document.getElementById("bg").style.display ="block";
                    document.getElementById("show").style.display ="block";
                    //帆软报表url
                    $("#ppxx").after('<iframe src="'+window.context.front+"templateReport/bfc_czj%2Fpreview=false%3Fparam=finereportUrl2"+'" style="height: 75%;width: 60%;"></iframe>');
                    $("#pwbh").text("铺位编号："+d.name);
                    $("#lc").text("楼层：负"+d.fnum+"楼");
                    $("#ppmc").text("品牌名称："+d.name);
                    $("#zbx").text("坐标x："+d.x);
                    $("#zby").text("坐标y："+d.y);
                };
                break;
        }
        _this.map.moveTo(d);
    });

    //开启点击查询
    $('#btnPick').on('click', function() {
      startPick = true;
    });
    //关闭点击查询
    $('#btnPickend').on('click', function() {
      startPick = false;
      map.selectNull();
    });
  }
  
    /**
      * 销毁地图
      */
    destroyMap() {
      this.map.dumpScene();
      this.map = null;
    }
  }
  
  export default new MapApplication;